'use strict';

// Constructor
export class PromoBlockWithCarousel {
    constructor() {
        var carousel = $('.paragraph--type--fancy-promo-block-full-carousel .field--name-field-items');
        // console.clear();

        carousel.each(function (i, menuitem) {
            var $this = $(this);

            $this.on('init', function () {
                var dots = $this.find('.slick-dots').addClass('visually-hidden');
                setTimeout(function () {
                    $this.find('.block-media').each(function () {
                        var slide = $(this).closest('.slick-slide');
                        var slideIndex = slide.data('slick-index');

                        var dotsCloned = dots.clone();

                        dotsCloned.removeClass('visually-hidden')
                        dotsCloned.find('li').removeClass('slick-active');
                        dotsCloned.find('li').addClass('slick-active-' + slideIndex);
                        dotsCloned.find(`li:nth-child(${slideIndex + 1})`).addClass('slick-active');
                        $(this).append(dotsCloned);

                        $(this).find('.slick-dots button').click(function (e) {
                            e.stopPropagation();
                            dots.find(`#${$(this).attr('id')}`).click();
                        });
                    });
                }, 2000);
            });
            $this.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: carousel.find('> .field__item').length > 1,
                autoplay: true,
                autoplaySpeed: 2000,
                arrows: false,
                centerMode: false,
                nextArrow: '<button type="button" class="slick-next"><span class="icon-chevron"></span></button>',
                prevArrow: '<button type="button" class="slick-prev"><span class="icon-chevron"`></span></button>'
            });

            // console.log($this);
            $this.on('click', function () {
                $this.slick('slickPause');
                console.log('Carousel paused');
            })
            $this.find('iframe').on('click', function () {
                console.log('here');
                $this.slick('slickPause');
            })
        });
    }
}